/**
 * Time formatting utilities
 */

/**
 * Format seconds to MM:SS display
 */
export function formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Format seconds to MM:SS.mmm display (with milliseconds)
 * Used in edit mode for precision
 */
export function formatTimeMs(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const ms = Math.floor((seconds % 1) * 1000);
    return `${mins}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
}

/**
 * Parse time string to seconds
 * Supports: "1:23", "1:23.456", "83.456"
 */
export function parseTime(timeStr: string): number | null {
    const trimmed = timeStr.trim();

    // Format: MM:SS or MM:SS.mmm
    const colonMatch = trimmed.match(/^(\d+):(\d{1,2})(?:\.(\d{1,3}))?$/);
    if (colonMatch) {
        const mins = parseInt(colonMatch[1], 10);
        const secs = parseInt(colonMatch[2], 10);
        const ms = colonMatch[3] ? parseInt(colonMatch[3].padEnd(3, '0'), 10) : 0;
        return mins * 60 + secs + ms / 1000;
    }

    // Format: plain seconds (e.g., "83.456")
    const num = parseFloat(trimmed);
    if (!isNaN(num) && num >= 0) {
        return num;
    }

    return null;
}
